import {
  SET_ACCOUNT_FORM_FIELD,
  SET_ACCOUNT_FORM,
  MERGE_ACCOUNT_FORM
} from 'actions/account/account/actionTypes'

const form = (state = {}, action) => {
  switch (action.type) {
    case SET_ACCOUNT_FORM_FIELD:
      return Object.assign({}, state, { [action.field]: action.value })
    case SET_ACCOUNT_FORM:
      return action.data
    case MERGE_ACCOUNT_FORM:
      return Object.assign({}, state, action.data)
    default:
      return state
  }
}

export default form
